import { useEffect, useState } from 'react';

export default function Advantages() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      try {
        setOffset(window.scrollY);
      } catch (e) {
        console.warn('Scroll handler failed:', e);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const advantages = [
    {
      icon: 'ri-award-line',
      title: '99% de Precisión Garantizada',
      description: 'Tecnología OMR de última generación que asegura resultados exactos',
      accent: '#0D9488'
    },
    {
      icon: 'ri-time-line',
      title: 'Ahorro de Tiempo Significativo',
      description: 'Procesa miles de evaluaciones en minutos, no en días',
      accent: '#F59E0B'
    },
    {
      icon: 'ri-error-warning-line',
      title: 'Cero Errores Humanos',
      description: 'Eliminamos completamente los errores de calificación manual',
      accent: '#0D9488'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Resultados en 24 Horas',
      description: 'Entrega rápida de informes detallados y análisis completos',
      accent: '#F59E0B'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Confidencialidad Total',
      description: 'Protección absoluta de datos con protocolos de seguridad avanzados',
      accent: '#0D9488'
    },
  ];

  return (
    <section id="advantages" className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fd462397e2d178a23f0a68118c6cb8d7.jpg"
          alt="Tecnología OMR F&A Digital"
          className="absolute w-full h-full object-cover object-top"
          style={{
            transform: `translateY(${(offset - 2000) * 0.08}px) scale(1.05)`,
            transition: 'transform 0.1s ease-out',
          }}
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A2E]/90 via-[#1A1A2E]/85 to-[#1A1A2E]/90"></div>

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-3 h-3 bg-[#F59E0B] rounded-full top-[15%] left-[25%] opacity-40 animate-pulse-slow"></div>
        <div className="absolute w-2 h-2 bg-[#0D9488] rounded-full top-[40%] left-[75%] opacity-30 animate-pulse-medium"></div>
        <div className="absolute w-4 h-4 bg-[#F59E0B] rounded-full bottom-[20%] left-[40%] opacity-25 animate-pulse-slow"></div>
        <div className="absolute w-2 h-2 bg-[#0D9488] rounded-full top-[60%] left-[15%] opacity-20 animate-pulse-medium"></div>
        <div className="absolute w-3 h-3 bg-white rounded-full top-[25%] right-[20%] opacity-15 animate-pulse-slow"></div>

        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-[20%] left-0 w-full h-px bg-gradient-to-r from-transparent via-[#0D9488] to-transparent animate-scan-line"></div>
          <div className="absolute top-[60%] left-0 w-full h-px bg-gradient-to-r from-transparent via-[#F59E0B] to-transparent animate-scan-line-delayed"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F59E0B]/20 border border-[#F59E0B]/30 px-4 md:px-5 py-2 rounded-full mb-4">
            <i className="ri-star-line text-[#F59E0B] text-sm md:text-base"></i>
            <span className="text-[#F59E0B] font-semibold text-xs md:text-sm">Nuestras Ventajas</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 px-4">
            ¿Por Qué Elegir <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D9488] to-[#F59E0B]">F&amp;A Digital?</span>
          </h2>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto px-4">
            Ventajas competitivas que nos hacen líderes en evaluación automatizada
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-8 md:mt-12">
          {advantages.slice(0, 3).map((advantage, index) => (
            <div
              key={index}
              className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all" style={{ backgroundColor: `${advantage.accent}15` }}>
                  <i className={`${advantage.icon} text-xl md:text-2xl`} style={{ color: advantage.accent }}></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-[#1A1A2E] mb-2 group-hover:text-[#0D9488] transition-colors">
                    {advantage.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6 max-w-4xl mx-auto">
          {advantages.slice(3).map((advantage, index) => (
            <div
              key={index}
              className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${advantage.accent}15` }}>
                  <i className={`${advantage.icon} text-xl md:text-2xl`} style={{ color: advantage.accent }}></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-[#1A1A2E] mb-2 group-hover:text-[#0D9488] transition-colors">
                    {advantage.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}